import { render } from "./AddOrganizationModal.vue?vue&type=template&id=9ae24262"
import script from "./AddOrganizationModal.vue?vue&type=script&lang=js"
export * from "./AddOrganizationModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__